<template>
  <div class="">
    <div class="flex items-center">
      <div class="">
        <div class="label-standard">{{ label }}</div>
        <div v-if="subLabel != null" class="mt-2 text-gray-900">{{ subLabel }}</div>
      </div>

      <div class="ml-2 text-gray-600 hover:text-gray-900 text-sm">
        <img src="https://cdn2.iconfinder.com/data/icons/officeicons/PNG/48/Help.png" 
          class="w-4 inline"
          v-if="tooltip != null" 
          v-tooltip.top="{ content: tooltip }" />
      </div>
    </div>

    <div class="form-line">
      <textarea
        class="input-standard"
        style="height:150px;"
        :value="value"
        v-on:blur="updateValue({
          objectType: objectType,
          key       : propertyKey, 
          value     : $event.target.value
        })"></textarea>
    </div>

    <div v-if="footerLabel != null" class="mt-2 text-sm text-gray-700">{{ footerLabel }}</div>
  </div>
</template>

<script>

  export default {

    props : {
      label : {
        type    : String,
        required: false
      },

      subLabel : {
        type    : String,
        required: false
      },

      footerLabel : {
        type    : String,
        required: false
      },

      tooltip : {
        type    : String,
        required: false
      },

      propertyKey : {
        type    : String,
        required: false
      },

      objectType : {
        type    : String,
        required: false
      },

      value : {
        type    : String,
        required: false
      },

      updateValue : {
        type : Function,
        required : false
      }

    },

    // data() {
    //   return {
    //     localValue : this.value
    //   }
    // },

    // methods : {
    //   // updateValueLocally() {
    //   //   this.updateValue(this.localValue)
    //   // }
    // }

  }
</script>